
import {
  Component,
  ActionButtonConfig,
  FormModalMixins,
  menuRouteHelper,
  systemConst,
  Prop,
  PageResultModalMixins
} from "@/lib";
import { DeclarationElementProductDto } from "@/store/modules/shipment/declarecustoms/productelement";
import CopyDeclarationElementModal  from "./copy-declaration-element.vue"
import CopyProductElement from "@/store/modules/shipment/declarecustoms/copyproductelement";

@Component({ components: { CopyDeclarationElementModal } })
export default class CreateCheckPointSetting extends FormModalMixins {
  @Prop({type: String}) targetShippingNumber: string;// 目标记录的运编号
  model = new DeclarationElementProductDto();
  created() {
    Object.assign(this.config, {
      modelTitleL: "Action.Edit",
      labelWidth: 100,
      width: 900,
      isHideOk: true,
       isHideCancel:true
    });
  }
  get column() {
    return [
      this.$util.render.baseColumn("app.SystemCode.SequenceNo", 80, {
        slot: "elementNo",
        minWidth: 80,
      }),
      this.$util.render.baseColumn(
        "app.CustomsDeclarationElement.ElementItem",
        null,
        {
          slot: "element",
          minWidth: 120,
        }
      ),
      this.$util.render.baseColumn("", null, {
        slot: "elementValue",
        minWidth: 140,
      }),
    ];
  }
  get record() {
    var tt = this.$store.state.shipment.declarecustoms.editElement;
    return tt;
  }
  get productName() {
    let declarationElement = this.model.declarationElementDtoList.find(x=>x.element === "品名" && !!x.elementValue);
    if (declarationElement) {
      return declarationElement.elementValue;
    }
    return this.model.productName;
  }
  close() {
    this.config.isShow = false;


  }
  async saveValue() {
    (this.$refs["form-modal"] as any).formValidate(async () => {
       {
        var elementstr = "";
        this.model.declarationElementDtoList.forEach((item, index) => {
          elementstr =
            elementstr +
            item.elementNo +
            "." +
            item.element +
            ":" +
            item.elementValue +
            ";";
        });
        this.model.productElement = elementstr;
        this.saveSuccess(this.model);
      }
    });
  }

  // 复制
  copy() {
    if (!this.productName) {
      this.$Modal.info({
          title: this.L("MessageTitle.Tips"),
          content: this.L("app.CustomsDeclarationElement.ProductNameCannotBeEmpty")
      });
      return;
    }
    this.$store.commit("shipment/declarecustoms/setCopyProductElement", {});
    (this.$refs["copy-declaration-element-modal"] as any).open();
  }

  copySuccess(result: CopyProductElement) {
    this.model.declarationElementDtoList.forEach(item => {
      let declarationElement = result.declarationElementProductDto.declarationElementDtoList.find(x => x.element == item.element);
      if (declarationElement) {
        item.elementValue = declarationElement.elementValue;
      }
    })
  }
}
